<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2">
            <i class="fa fa-file-text-o text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Notas Fiscais (NF-e)</h4>
            <p class="text-muted mb-0 small">Gerenciamento e emissão de documentos fiscais eletrônicos</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <!-- Search Pill -->
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                  <b-button variant="link" class="btn-icon-only text-muted" @click="consultarStatusServico" :disabled="consultandoStatusServico" v-b-tooltip.hover title="Status do Serviço SEFAZ">
                    <i :class="consultandoStatusServico ? 'fa fa-spinner fa-spin text-info' : 'fa fa-refresh text-info'"></i>
                  </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-code-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-success" :disabled="exportandoXmlLote" @click="abrirConfirmacaoExportarXmlLote()" v-b-tooltip.hover title="Exportar XML filtradas">
                        <i :class="exportandoXmlLote ? 'fa fa-spinner fa-spin' : 'fa fa-download'"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-select v-model="tipoData" :options="tipoDataOptions" class="border-0 bg-transparent py-0 mr-2" style="width: 130px" @change="pesquisar()" />
                    <CecInputData ref="dt1Input" v-model="dt1" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                    <CecInputData v-model="dt2" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                    <div class="border-left ml-2 pl-2">
                      <b-form-input type="text" v-model="chave" placeholder="Chave de Acesso..." class="border-0 bg-transparent" style="width: 200px" @keydown.enter.native="pesquisar()" />
                    </div>
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click.stop.prevent="abrirCriar()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span>Nova NF-e</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">ID Controle</label>
                      <b-form-input type="text" v-model="id" placeholder="ID" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Número NF-e</label>
                      <b-form-input type="text" v-model="nota1" placeholder="Nº Inicial" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="3">
                      <label class="font-weight-bold text-muted small">Situação</label>
                      <b-form-select v-model="status" :options="statusOptions" class="custom-input-premium" @change="pesquisar()" @keydown.enter.native="pesquisar()"></b-form-select>
                    </b-col>
                    <b-col md="5">
                      <label class="font-weight-bold text-muted small">Chave de Acesso</label>
                      <b-form-input type="text" v-model="chave" placeholder="44 dígitos" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-3">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table
              class="modern-premium-table mb-0"
              id="table-nfe"
              ref="tbl"
              show-empty
              empty-text="Informe o filtro para ver os registros"
              responsive
              :sticky-header="stickyHeight"
              hover
              small
              :busy.sync="isBusy"
              :items="itensFiltrados"
              :fields="colunas"
              :current-page="currentPage"
              :per-page="perPage"
              :dark="isDark"
              @row-dblclicked="abrirCadastro"
              @row-clicked="clicarLinha"
              :tbody-tr-class="rowClassSelecionado"
            >

              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(TX_NUM_NFE)>
                <SetFilter label="Número" v-model="filtros.TX_NUM_NFE" :options="opcoes.TX_NUM_NFE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(DT_EMISSAO)>
                <SetFilter label="Emissão" v-model="filtros.DT_EMISSAO" :options="opcoes.DT_EMISSAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(TX_CHAVE_ACESSO)>
                <SetFilter label="Chave" v-model="filtros.TX_CHAVE_ACESSO" :options="opcoes.TX_CHAVE_ACESSO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(DT_SADIA_ENTRADA)>
                <SetFilter label="Saí/Ent" v-model="filtros.DT_SADIA_ENTRADA" :options="opcoes.DT_SADIA_ENTRADA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(OP_FORMA_PAGAMENTO_TRADUZIDO)>
                <SetFilter label="Forma Pgto" v-model="filtros.OP_FORMA_PAGAMENTO_TRADUZIDO" :options="opcoes.OP_FORMA_PAGAMENTO_TRADUZIDO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(ID_CLIENTE_NFE)>
                <SetFilter label="(ID)" v-model="filtros.ID_CLIENTE_NFE" :options="opcoes.ID_CLIENTE_NFE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(ID_SERIE)>
                <SetFilter label="Série" v-model="filtros.ID_SERIE" :options="opcoes.ID_SERIE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(CFOP_ID)>
                <SetFilter label="CFOP" v-model="filtros.CFOP_ID" :options="opcoes.CFOP_ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(OP_TIPO_DOCUMENTO_TRADUZIDO)>
                <SetFilter label="Tipo" v-model="filtros.OP_TIPO_DOCUMENTO_TRADUZIDO" :options="opcoes.OP_TIPO_DOCUMENTO_TRADUZIDO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(TX_NOME_CLIENTE)>
                <SetFilter label="Cliente" v-model="filtros.TX_NOME_CLIENTE" :options="opcoes.TX_NOME_CLIENTE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(TX_NUM_CNPJ_DEST)>
                <SetFilter label="CNPJ Dest." v-model="filtros.TX_NUM_CNPJ_DEST" :options="opcoes.TX_NUM_CNPJ_DEST" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(ID_SEQUENCIA_VENDAS)>
                <SetFilter label="Pré-Fatura" v-model="filtros.ID_SEQUENCIA_VENDAS" :options="opcoes.ID_SEQUENCIA_VENDAS" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(OP_STATUS_TRADUZIDO)>
                <SetFilter label="Situação" v-model="filtros.OP_STATUS_TRADUZIDO" :options="opcoes.OP_STATUS_TRADUZIDO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(EXISTE_BOLETO)>
                <SetFilter label="Boleto" v-model="filtros.EXISTE_BOLETO" :options="opcoes.EXISTE_BOLETO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #head(VL_TOTAL_NFE)>
                <SetFilter label="Total" v-model="filtros.VL_TOTAL_NFE" :options="opcoes.VL_TOTAL_NFE" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>

              <template #cell(ID)="data">
                <span class="text-muted font-weight-bold">{{ data.value }}</span>
              </template>

              <template #cell(DETALHE)="row">
                <i 
                  :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                  @click.stop="toggleDetalhesNfe(row)"
                  style="cursor: pointer"
                ></i>
              </template>

              <template #cell(TX_NUM_NFE)="data">
                <span class="font-weight-bold text-dark">{{ data.value }}</span>
              </template>

              <template #cell(DT_EMISSAO)="item">
                <span class="text-muted">{{ formatDate(item.item.DT_EMISSAO) }}</span>
              </template>

              <template #cell(TX_CHAVE_ACESSO)="item">
                <div class="text-truncate text-muted" style="max-width: 220px;" :title="item.item.TX_CHAVE_ACESSO">
                  {{ item.item.TX_CHAVE_ACESSO || '-' }}
                </div>
              </template>

              <template #cell(DT_SADIA_ENTRADA)="item">
                <span class="text-muted">{{ formatDate(item.item.DT_SADIA_ENTRADA) }}</span>
              </template>

              <template #cell(OP_FORMA_PAGAMENTO_TRADUZIDO)="item">
                <span class="text-muted">{{ item.item.OP_FORMA_PAGAMENTO_TRADUZIDO || '-' }}</span>
              </template>

              <template #cell(ID_CLIENTE_NFE)="data">
                <span class="text-muted">{{ data.value }}</span>
              </template>

              <template #cell(TX_NOME_CLIENTE)="data">
                <div class="text-truncate" style="max-width: 250px;" :title="data.value">
                  {{ data.value }}
                </div>
              </template>

              <template #cell(VL_TOTAL_NFE)="item">
                <span class="font-weight-bold text-primary">{{ formatCurrency(item.item.VL_TOTAL_NFE) }}</span>
              </template>

              <template #cell(OP_STATUS_TRADUZIDO)="item">
                <b-badge pill :variant="colorirSITUACAO(item.item.OP_STATUS)" class="px-3 py-1 shadow-xs">
                  {{item.item.OP_STATUS_TRADUZIDO}}
                </b-badge>
              </template>

              <template #cell(EXISTE_BOLETO)="item">
                <i v-if="item.item.EXISTE_BOLETO === 'S'" class="fa fa-barcode text-secondary" v-b-tooltip.hover title="Boleto Gerado"></i>
                <span v-else>-</span>
              </template>

              <template #cell(actions)="item">
                <b-button-group size="sm">
                  <b-dropdown
                    right
                    dropup
                    boundary="viewport"
                    :popper-opts="{ positionFixed: true }"
                    no-caret
                    variant="link"
                    toggle-class="p-1 text-muted no-decoration"
                    @shown="clicarLinha(item.item)"
                  >
                    <template #button-content>
                      <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm">
                        <i class="fa fa-ellipsis-v"></i>
                      </b-button>
                    </template>

                    <b-dropdown-item 
                      :disabled="String(item.item.OP_STATUS || '').trim() !== '2'"
                      @click.stop="imprimirDanfeLista(item.item)">
                      <i class="fa fa-print text-primary mr-2"></i> Imprimir DANFE
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.OP_STATUS || '').trim() !== '2'"
                      @click.stop="abrirDanfeEmail(item.item)">
                      <i class="fa fa-envelope text-info mr-2"></i> Enviar por Email
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item 
                      :disabled="String(item.item.OP_STATUS || '').trim() !== '2'"
                      @click.stop="abrirModalCartaCorrecao(item.item)">
                      <i class="fa fa-pencil text-warning mr-2"></i> Carta de Correção
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.OP_STATUS || '').trim() !== '2'"
                      @click.stop="abrirModalCancelarNfe(item.item)">
                      <i class="fa fa-ban text-danger mr-2"></i> Cancelar NF-e
                    </b-dropdown-item>

                    <b-dropdown-item 
                      :disabled="String(item.item.OP_STATUS || '').trim() !== '2'"
                      @click.stop="abrirModalExportarXml(item.item)">
                      <i class="fa fa-file-code-o text-success mr-2"></i> Exportar XML
                    </b-dropdown-item>

                    <b-dropdown-divider v-if="item.item.ID_SEQUENCIA_VENDAS"></b-dropdown-divider>

                    <b-dropdown-item 
                      v-if="item.item.ID_SEQUENCIA_VENDAS"
                      @click.stop="abrirModalDesvincularPreFatura(item.item)">
                      <i class="fa fa-chain-broken text-danger mr-2"></i> Desvincular Pré-Fatura
                    </b-dropdown-item>

                    <b-dropdown-divider></b-dropdown-divider>

                    <b-dropdown-item 
                      :disabled="String(item.item.OP_STATUS || '').trim() !== '1' && String(item.item.OP_STATUS || '').trim() !== '5'"
                      @click.stop="deleteItem(item.item)" 
                      class="text-danger">
                      <i class="fa fa-trash text-danger mr-2"></i> Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </b-button-group>
              </template>

              <template #custom-foot="{ fields, items }">
                <b-tr class="bg-light font-weight-bold">
                  <b-td colspan="16">Total de Registros: {{ itensFiltrados.length }}</b-td>
                  <b-td colspan="2" class="text-right text-primary">
                     {{ vlTotalNfeRodape }}
                  </b-td>
                </b-tr>
              </template>

              <template #row-details="row">
                <div class="px-4 py-2 bg-light border-top">
                  <div v-if="row.item.loading" class="text-center p-4">
                    <b-spinner small variant="primary"></b-spinner>
                    <span class="ml-2 font-weight-bold text-primary">Carregando itens da NF-e...</span>
                  </div>
                  <div v-else>
                    <b-table 
                      small
                      hover
                      responsive
                      :items="row.item.detalhes" 
                      :fields="tabelaItensFields"
                      class="bg-white border rounded shadow-sm mb-0"
                    >
                      <template #cell(codigo)="data">
                        <span class="text-muted font-weight-bold">#{{ data.item.ID_PRODUTO || '' }}</span>
                      </template>
                      <template #cell(descricao)="data">
                        <div class="font-weight-bold text-dark">{{ data.item.TX_DESCRICAO }}</div>
                      </template>
                      <template #cell(ncm)="data">
                        <b-badge variant="light" class="border text-muted">{{ data.item.TX_NCM || '-' }}</b-badge>
                      </template>
                      <template #cell(unidade)="data">
                        <span class="badge badge-soft-info">{{ data.item.ID_UNIDADE_COMERCIAL || '' }}</span>
                      </template>
                      <template #cell(qtd)="data">
                        <span class="font-weight-bold">{{ Number(data.item.NR_QUANT_COMERCIAL || 0).toLocaleString('pt-BR') }}</span>
                      </template>
                      <template #cell(vl_unitario)="data">
                        <span class="text-muted">{{ formatCurrency(data.item.VL_UNITARIO_COMERCIAL) }}</span>
                      </template>
                      <template #cell(vl_total)="data">
                        <span class="font-weight-bold text-primary">{{ formatCurrency(data.item.VL_TOTAL_BRUTO) }}</span>
                      </template>
                      <template #cell(icms)="data">
                        <span class="text-info small font-weight-bold">{{ formatCurrency(data.item.VL_ICMS) }}</span>
                      </template>
                      <template #cell(ipi)="data">
                        <span class="text-warning small font-weight-bold">{{ formatCurrency(data.item.VL_IPI) }}</span>
                      </template>
                      <template #cell(pis)="data">
                        <span class="text-secondary small">{{ formatCurrency(data.item.VL_PIS) }}</span>
                      </template>
                      <template #cell(cofins)="data">
                        <span class="text-secondary small">{{ formatCurrency(data.item.VL_COFINS) }}</span>
                      </template>
                    </b-table>
                  </div>
                </div>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>

      <criar-nfe-modal ref="modal-criar" @create="onNfeCreated"/>
      <danfe-email-modal ref="modal-danfe" @sent="onDanfeSent"/>
      <carta-correcao-modal ref="modal-carta-correcao" @carta-enviada="onCartaEnviada" />
      <cancelar-nfe-modal ref="modal-cancelar-nfe" @nfe-cancelada="onNfeCancelada" />
      <excluir-nfe-modal ref="modal-excluir-nfe" @nfe-excluida="onNfeExcluida" />

      <!-- Modal de Confirmação para Resultados Grandes -->
      <ModalAlertaResultadoGrande
        ref="modalConfirmarResultadoGrande"
        :count="resultadoPendenteCount"
        @confirmar="confirmarCarregarResultadoGrande"
        @cancelar="cancelarCarregarResultadoGrande"
      />

      <b-modal
        ref="modalExportarXmlLote"
        id="modal-exportar-xml-lote"
        hide-header
        hide-footer
        body-class="p-0 overflow-hidden"
        content-class="border-0 shadow-lg"
        centered
        size="xl"
      >
        <b-overlay :show="exportandoXmlLote" rounded="sm">
          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
            <div class="header-icon-wrapper mr-3 bg-white-10">
              <i class="fa fa-file-code-o text-white"></i>
            </div>
            <div>
              <h5 class="mb-0 font-weight-bold text-white">Exportar XML filtradas</h5>
              <small class="text-white opacity-75">Notas com XML disponivel no resultado filtrado atual</small>
            </div>
            <b-button variant="link" class="ml-auto text-white p-0 opacity-75" :disabled="exportandoXmlLote" @click="$refs.modalExportarXmlLote.hide()">
              <i class="fa fa-times fa-lg"></i>
            </b-button>
          </div>

          <div class="p-4 bg-light">
            <div class="modal-info-bar mb-4 bg-white border shadow-sm p-3 rounded">
              <b-row align-v="center">
                <b-col md="3">
                  <small class="modal-label-premium">Notas exportaveis</small>
                  <h4 class="mb-0 font-weight-bold text-primary">{{ resumoXmlLote.totalNotas }}</h4>
                </b-col>
                <b-col md="3" class="border-left">
                  <small class="modal-label-premium">Total das notas</small>
                  <h4 class="mb-0 font-weight-bold text-success">{{ formatCurrency(resumoXmlLote.totalValor) }}</h4>
                </b-col>
                <b-col md="3" class="border-left">
                  <small class="modal-label-premium">Notas filtradas</small>
                  <h4 class="mb-0 font-weight-bold text-dark">{{ resumoXmlLote.totalFiltradas }}</h4>
                </b-col>
                <b-col md="3" class="border-left">
                  <small class="modal-label-premium">Fora do lote</small>
                  <h4 class="mb-0 font-weight-bold text-muted">{{ resumoXmlLote.totalIgnoradas }}</h4>
                </b-col>
              </b-row>
            </div>

            <div class="modal-section-title mb-3">
              <i class="fa fa-tags mr-2 text-primary"></i> Situacao
            </div>
            <b-row class="mb-4">
              <b-col v-for="situacao in resumoXmlLote.porSituacao" :key="situacao.status" md="3" class="mb-3">
                <div class="p-3 bg-white rounded border shadow-xs h-100">
                  <small class="modal-label-premium">{{ situacao.label }}</small>
                  <div class="d-flex align-items-end justify-content-between">
                    <h4 class="mb-0 font-weight-bold text-dark">{{ situacao.quantidade }}</h4>
                    <strong class="text-success">{{ formatCurrency(situacao.valor) }}</strong>
                  </div>
                </div>
              </b-col>
            </b-row>

            <div class="modal-section-title mb-3">
              <i class="fa fa-address-card-o mr-2 text-primary"></i> Destinatario / Remetente
            </div>
            <div class="bg-white rounded border shadow-xs overflow-hidden">
              <b-table
                small
                responsive
                hover
                class="modern-premium-table mb-0"
                :items="resumoXmlLote.porPessoa"
                :fields="resumoXmlLoteCamposPessoa"
                show-empty
                empty-text="Nenhum destinatario/remetente para exportacao"
              >
                <template #cell(valor)="data">
                  <span class="font-weight-bold text-success">{{ formatCurrency(data.item.valor) }}</span>
                </template>
              </b-table>
            </div>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
            <b-button variant="soft-danger" pill class="px-4 font-weight-bold" :disabled="exportandoXmlLote" @click="$refs.modalExportarXmlLote.hide()">
              CANCELAR
            </b-button>
            <b-button variant="success" pill class="px-5 font-weight-bold shadow-sm" :disabled="exportandoXmlLote || !resumoXmlLote.totalNotas" @click="confirmarExportarXmlLote()">
              <i :class="exportandoXmlLote ? 'fa fa-spinner fa-spin mr-1' : 'fa fa-download mr-1'"></i>
              EXPORTAR ZIP
            </b-button>
          </div>
        </b-overlay>
      </b-modal>

      <!-- dynamic modal for opening the full NF-e editor without route navigation -->
      <b-modal size="xl" :visible.sync="showCadastroModal" hide-footer @hidden="onCadastroModalHidden">
        <component v-if="CadastroComp" :is="CadastroComp" :id="cadastroId" />
      </b-modal>

    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import CriarNfeModal from './partials/CriarNfeModal.vue'
import DanfeEmailModal from './partials/DanfeEmailModal.vue'
import CartaCorrecaoModal from './partials/CartaCorrecaoModal.vue'
import CancelarNfeModal from './partials/CancelarNfeModal.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import CecInputData from '@/components/Cec/CecInputData.vue'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import ExcluirNfeModal from './partials/ExcluirNfeModal.vue'

export default {
  components: { SetFilter, CriarNfeModal, DanfeEmailModal, CartaCorrecaoModal, CancelarNfeModal, ExcluirNfeModal, CecInputData, ModalAlertaResultadoGrande },
  mixins: [createCecTableToolsMixin({ rowsProp: 'lista', tblRef: 'tbl', useExternalPaging: true, filters: [
    { key: 'ID', type: 'number', label: 'ID' },
    { key: 'TX_NUM_NFE', type: 'string', label: 'Número' },
    { key: 'ID_SERIE', type: 'string', label: 'Série' },
    { key: 'CFOP_ID', type: 'string', label: 'CFOP' },
    { key: 'OP_TIPO_DOCUMENTO_TRADUZIDO', type: 'string', label: 'Tipo' },
    { key: 'DT_EMISSAO', type: 'date', label: 'Emissão' },
    { key: 'TX_CHAVE_ACESSO', type: 'string', label: 'Chave de Acesso' },
    { key: 'DT_SADIA_ENTRADA', type: 'date', label: 'Saí/Ent' },
    { key: 'OP_FORMA_PAGAMENTO_TRADUZIDO', type: 'string', label: 'Forma de Pagamento' },
    { key: 'ID_CLIENTE_NFE', type: 'number', label: '(ID)' },
    { key: 'TX_NOME_CLIENTE', type: 'string', label: 'Cliente' },
    { key: 'TX_NUM_CNPJ_DEST', type: 'string', label: 'CNPJ Dest.' },
    { key: 'ID_SEQUENCIA_VENDAS', type: 'number', label: 'Pré-Fatura' },
    { key: 'OP_STATUS_TRADUZIDO', type: 'string', label: 'Situação' },
    { key: 'EXISTE_BOLETO', type: 'string', label: 'Boleto' },
    { key: 'VL_TOTAL_NFE', type: 'number', label: 'Total' }
  ] })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      statusOptions: [
        { value: null, text: 'Todas as Situações' },
        { value: '5', text: 'Em Digitação' },
        { value: '2', text: 'Autorizada' },
        { value: '3', text: 'Cancelada' },
        { value: '4', text: 'Denegada' },
        { value: '7', text: 'Rejeitada' },
        { value: '1', text: 'Assinada/Validada' },
        { value: '8', text: 'Pendente' }
      ],
      tipoDataOptions: [
        { value: 'EMISSAO', text: 'Emissão' },
        { value: 'SAIDA', text: 'Saí/Ent' }
      ],
      colunas: [
        { key: 'DETALHE', label: '', class:'align-middle text-center', thStyle: { width: '3%' }, sortable: false },
        { key: 'ID', label: 'ID', sortable: true, class:'align-middle text-right', thStyle: { width: '6%' } },
        { key: 'TX_NUM_NFE', label: 'Número', sortable: true, class:'align-middle', thStyle: { width: '8%' } },
        { key: 'ID_SERIE', label: 'Série', sortable: true, class:'align-middle', thStyle: { width: '6%' } },
        { key: 'CFOP_ID', label: 'CFOP', sortable: true, class:'align-middle', thStyle: { width: '6%' } },
        { key: 'OP_TIPO_DOCUMENTO_TRADUZIDO', label: 'Tipo', sortable: true, class:'align-middle', thStyle: { width: '8%' } },
        { key: 'DT_EMISSAO', label: 'Emissão', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'TX_CHAVE_ACESSO', label: 'Chave de Acesso', sortable: true, class:'align-middle', thStyle: { width: '14%' } },
        { key: 'DT_SADIA_ENTRADA', label: 'Saí/Ent', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'OP_FORMA_PAGAMENTO_TRADUZIDO', label: 'Forma de Pagamento', sortable: true, class:'align-middle', thStyle: { width: '12%' } },
        { key: 'ID_CLIENTE_NFE', label: '(ID)', sortable: true, class:'align-middle text-right', thStyle: { width: '6%' } },
        { key: 'TX_NOME_CLIENTE', label: 'Cliente', sortable: true, class:'align-middle', thStyle: { width: '18%' } },
        { key: 'TX_NUM_CNPJ_DEST', label: 'CNPJ Dest.', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'ID_SEQUENCIA_VENDAS', label: 'Pré-Fatura', sortable: true, class:'align-middle text-center', thStyle: { width: '8%' } },
        { key: 'OP_STATUS_TRADUZIDO', label: 'Situação', sortable: true, class:'align-middle', thStyle: { width: '10%' } },
        { key: 'EXISTE_BOLETO', label: 'Boleto', sortable: false, class:'align-middle text-center', thStyle: { width: '4%' } },
        { key: 'VL_TOTAL_NFE', label: 'Total', sortable: true, class:'align-middle text-right', thStyle: { width: '10%' } },
        { key: 'actions', label: 'Ações', class:'align-middle text-center p-0', thStyle: { width: '8%' }, sortable: false }
      ]
      ,
      tabelaItensFields: [
        { key: 'codigo', label: 'Cód.' , thStyle: { width: '6%' } },
        { key: 'descricao', label: 'Descrição' },
        { key: 'ncm', label: 'NCM', thStyle: { width: '8%' } },
        { key: 'unidade', label: 'Unid.', thStyle: { width: '6%' } },
        { key: 'qtd', label: 'Qtd', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'vl_unitario', label: 'Vlr Unit.', class: 'text-right', thStyle: { width: '10%' } },
        { key: 'vl_total', label: 'Total', class: 'text-right', thStyle: { width: '10%' } },
        { key: 'icms', label: 'ICMS', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'ipi', label: 'IPI', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'pis', label: 'PIS', class: 'text-right', thStyle: { width: '8%' } },
        { key: 'cofins', label: 'COFINS', class: 'text-right', thStyle: { width: '8%' } }
      ],
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      consultandoStatusServico: false,
      exportandoXmlLote: false,
      resumoXmlLote: {
        totalNotas: 0,
        totalFiltradas: 0,
        totalIgnoradas: 0,
        totalValor: 0,
        nfeIds: [],
        porSituacao: [],
        porPessoa: []
      },
      resumoXmlLoteCamposPessoa: [
        { key: 'nome', label: 'Destinatario / Remetente', class: 'align-middle' },
        { key: 'documento', label: 'Documento', class: 'align-middle' },
        { key: 'quantidade', label: 'Notas', class: 'align-middle text-right' },
        { key: 'valor', label: 'Total', class: 'align-middle text-right' }
      ],
      // modal editor state
      CadastroComp: null,
      cadastroId: null,
      showCadastroModal: false
    }
  },

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('nfe', ['LISTA','DT1','DT2','TIPO_DATA','ID','CHAVE','NVENDA','FORMA','NOTA1','NOTA2','STATUS','REGISTRO_SELECIONADO_ID','PAGINA_ATUAL','PER_PAGE']),

    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('nfe/SET_LISTA', v) }
    },
    dt1: {
      get() { return this.$store.getters['nfe/DT1'] },
      set(v) { this.$store.commit('nfe/SET_DT1', v) }
    },
    dt2: {
      get() { return this.$store.getters['nfe/DT2'] },
      set(v) { this.$store.commit('nfe/SET_DT2', v) }
    },
    tipoData: {
      get() { return this.$store.getters['nfe/TIPO_DATA'] },
      set(v) { this.$store.commit('nfe/SET_TIPO_DATA', v) }
    },
    chave: {
      get() { return this.$store.getters['nfe/CHAVE'] },
      set(v) { this.$store.commit('nfe/SET_CHAVE', v) }
    },
    status: {
      get() { return this.$store.getters['nfe/STATUS'] },
      set(v) { this.$store.commit('nfe/SET_STATUS', v) }
    },
    id: {
      get() { return this.$store.getters['nfe/ID'] },
      set(v) { this.$store.commit('nfe/SET_ID', v) }
    },
    nota1: {
      get() { return this.$store.getters['nfe/NOTA1'] },
      set(v) { this.$store.commit('nfe/SET_NOTA1', v) }
    },
    currentPage: {
      get () { return this.$store.getters['nfe/PAGINA_ATUAL'] },
      set (value) { this.$store.commit('nfe/SET_PAGINA_ATUAL', value); }
    },
    perPage: {
      get () { return this.$store.getters['nfe/PER_PAGE'] || 25 },
      set (v) { this.$store.commit('nfe/SET_PER_PAGE', Number(v) || 25) }
    },
    deveRecarregarLista() {
      return this.$store.getters['nfe/DEVE_RECARREGAR_LISTA']
    },
    vlTotalNfeRodape() {
      if (!this.itensFiltrados || this.itensFiltrados.length === 0) return this.formatCurrency(0)
      const total = this.itensFiltrados.reduce((acc, item) => acc + (Number(item.VL_TOTAL_NFE) || 0), 0)
      return this.formatCurrency(total)
    }
  },

  watch: {
    deveRecarregarLista(novoValor) {
      if (novoValor === true) {
        // Apenas recarregar - o ID selecionado já foi setado antes de navegar
        this.pesquisar()
        this.$store.commit('nfe/SET_DEVE_RECARREGAR_LISTA', false)
      }
    }
  },

  methods: {
  clicarLinha(item) { this.$store.commit('nfe/SET_REGISTRO_SELECIONADO_ID', item.ID) },
  rowClassSelecionado(item, type) { if (type !== 'row' || !item) return ''; const selId = this.$store.getters['nfe/REGISTRO_SELECIONADO_ID']; return item.ID === selId ? 'cec-row-selected' : '' },
    colorirSITUACAO(s) {
      if (!s) return 'secondary'
      const txt = String(s).toUpperCase()
      if (txt.includes('2') ) return 'success'
      if (txt.includes('3') ) return 'danger'
      if (txt.includes('5') ) return 'warning'
      if (txt.includes('7') ) return 'purple'
      return 'secondary'
    },
    traduzirSITUACAO(s) { return s ? String(s).trim() : '' },
    limparFiltro() { 
      this.$store.commit('nfe/SET_LIMPAR', null); 
      this.filtroAvancado = false;
    },
    novo() {
      // abrir modal de criação em vez de navegar imediatamente para evitar carregamento de chunks
      if (this.$refs['modal-criar'] && this.$refs['modal-criar'].show) {
        this.$refs['modal-criar'].show()
        return
      }
      // fallback: navegar
      this.$router.push(`/faturamento/nfe/add`)
    },

    
    abrirCadastro(item) {
      // Follow project convention used by Venda: set selected id in store then navigate via router.
      const id = item && (item.ID || item.SEQUENCIA) ? (item.ID || item.SEQUENCIA) : null
      if (!id) return

      // mark selected record in nfe store so the editor can read it
      try {
        if (this.$store && this.$store.commit) this.$store.commit('nfe/SET_REGISTRO_SELECIONADO_ID', id)
      } catch (err) {
        // ignore
      }

      // Use router navigation (no awaiting) to keep guards and history consistent, matching Venda pattern
      try {
        this.$router.push(`/faturamento/nfe/cadastro/${id}`)
      } catch (err) {
        // last-resort fallback: show toast and do nothing else — avoid dynamic import fallback to keep behavior consistent
        console.error('Erro ao navegar para o editor NF-e:', err)
        this.$bvToast.toast('Falha ao abrir editor NF-e (ver console)', { title: 'Erro', variant: 'danger' })
      }
    },

    async pesquisar(limparSelecao = true) {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        if (limparSelecao) {
          this.$store.commit('nfe/SET_REGISTRO_SELECIONADO_ID', null)
          this.$store.commit('nfe/SET_PAGINA_ATUAL', 1)
        }

        const result = await this.$store.dispatch('nfe/GET_LISTA')

        // Verifica se precisa de confirmação
        if (result && result.needsConfirmation) {
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          this.$store.commit('controle/setAguardando', false)
          if (this.$refs.modalConfirmarResultadoGrande) {
            this.$refs.modalConfirmarResultadoGrande.show()
          }
          return
        }

      } catch (err) {
        console.error('Erro ao pesquisar NF-e:', err)
        this.lista = []
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    confirmarCarregarResultadoGrande() {
      if (this.resultadoPendente) {
        this.$store.commit('nfe/SET_LISTA', this.resultadoPendente)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
      if (this.$refs.modalConfirmarResultadoGrande) {
        this.$refs.modalConfirmarResultadoGrande.hide()
      }
    },

    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      if (this.$refs.modalConfirmarResultadoGrande) {
        this.$refs.modalConfirmarResultadoGrande.hide()
      }
    },

    deleteItem(item) {
      if (this.$refs['modal-excluir-nfe']) {
        this.$refs['modal-excluir-nfe'].abrir(item)
      } else {
        this.$bvToast.toast('Modal não disponível', { title: 'Erro', variant: 'danger' })
      }
    },

    onNfeExcluida() {
      // Recarregar lista após exclusão
      this.pesquisar()
    },

  abrirCriar() { this.novo() },

    abrirDanfeEmail(item) {
      if (this.$refs['modal-danfe'] && this.$refs['modal-danfe'].openFor) this.$refs['modal-danfe'].openFor(item)
      else this.$bvToast.toast('Enviar DANFE - modal não disponível', { title: 'Info', variant: 'info' })
    },

    async onNfeCreated(payload) {
      // Special flow for NF-e Avulsa
      const isAvulsa = payload && (payload.tipo === 'AVULSA' || payload.origem === 'AVULSA')
      
      try {
        // Para fluxo AVULSA, NÃO abre loading global - NfeCadastro gerencia seu próprio loading local
        if (isAvulsa) {
          // normalize payload shapes: modal emite payload plano na raiz
          const cfopId = payload.cfopId
          const sentido = payload.sentido
          const finalidade = payload.finalidade
          const tipoMovId = payload.tipoMovId
          const empresaId = payload.empresaId

          const nfeId = await this.$store.dispatch('nfe/START_AVULSA', {
            empresaId,
            cfopId,
            sentido,
            finalidade,
            tipoMovId
          })

          // clear filters and position the ID filter as requested
          this.limparFiltro()
          // set ID filter in store so GET_LISTA (if triggered) will focus
          this.$store.commit('nfe/SET_ID', nfeId)
          
          // Marcar que a lista precisa ser recarregada quando voltar
          this.$store.commit('nfe/SET_DEVE_RECARREGAR_LISTA', true)
          
          // navigate to the NFe cadastro in edit mode (NfeCadastro gerenciará o loading)
          this.$router.push({ name: 'NFe - Cadastro', params: { id: nfeId }, query: { acao: 'E' } })
          return
        }

        // Para outros fluxos (PRE_FATURA, etc), usa loading global
        this.$store.commit('controle/setAguardando', true)

        // Fallback / existing generic create flow for other types
        const resp = await this.$store.dispatch('nfe/CRIAR', payload)
        // refresh list
        await this.$store.dispatch('nfe/GET_LISTA')
        this.$bvToast.toast('NF-e criada', { title: 'Sucesso', variant: 'success' })
        // if backend returned the id, navigate to the created record (best-effort)
        try {
          const data = resp && resp.data ? resp.data : resp
          const newId = data && (data.ID || data.id || data.idNfe || data.nfeId)
          if (newId) {
            // Marcar que a lista precisa ser recarregada quando voltar
            this.$store.commit('nfe/SET_DEVE_RECARREGAR_LISTA', true)
            
            // Desligar aguardando ANTES de navegar
            this.$store.commit('controle/setAguardando', false)

            // Navigate (NfeCadastro setará o ID selecionado ao carregar)
            this.$router.push(`/faturamento/nfe/cadastro/${newId}`)
          }
        } catch (__) {
          // ignore navigation errors
        }

      } catch (err) {
        console.error('Erro ao criar NFe:', err)
        this.$bvToast.toast('Falha ao criar NF-e', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    onCadastroModalHidden() {
      // cleanup dynamic component to free memory and reset state
      this.CadastroComp = null
      this.cadastroId = null
      this.showCadastroModal = false
    },

    onDanfeSent() {},

    async consultarStatusServico() {
      if (this.consultandoStatusServico) return

      try {
        this.consultandoStatusServico = true

        const response = await this.$http.post('/api/protected/integrador/statusServico', {})
        const mensagem = response?.data?.msg || 'Status do serviço da SEFAZ consultado com sucesso.'

        await this.$bvModal.msgBoxOk(mensagem, {
          title: 'Status do Serviço SEFAZ',
          size: 'lg',
          okTitle: 'Fechar',
          centered: true,
          headerClass: 'bg-info text-white',
          bodyClass: 'text-pre-wrap'
        })
      } catch (err) {
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || (typeof err?.response?.data === 'string' ? err.response.data : null) || err?.message || 'Não foi possível consultar o status do serviço da SEFAZ.'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', mensagem)
      } finally {
        this.consultandoStatusServico = false
      }
    },

    async imprimirDanfeLista(nfe) {
      if (!nfe.ID) {
        this.$bvToast.toast('NF-e não possui ID válido', { variant: 'warning', solid: true })
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const body = {
          nfeId: nfe.ID,
          empresaId: nfe.ID_EMPRESA
        }

        const response = await this.$http.post(`/api/protected/notaFiscal/downloadPDF/`, body)
        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Não foi possível baixar o PDF da Nota Fiscal.'
          this.$bvToast.toast(erro, { title: 'Erro', variant: 'danger', solid: true })
          return
        }

        // Converte base64 para blob
        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })

        // Cria a URL e abre o PDF
        const url = window.URL.createObjectURL(blob)
        window.open(url)

      } catch (err) {
        console.error('Erro ao imprimir DANFE:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Erro ao imprimir DANFE'
        this.$bvToast.toast(mensagem, { title: 'Erro', variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    abrirModalCartaCorrecao(nfe) {
      if (this.$refs['modal-carta-correcao']) {
        this.$refs['modal-carta-correcao'].abrir(nfe)
      } else {
        this.$bvToast.toast('Modal não disponível', { title: 'Erro', variant: 'danger' })
      }
    },

    onCartaEnviada() {
      // Recarregar lista após envio da carta
      this.pesquisar()
    },

    abrirModalCancelarNfe(nfe) {
      if (this.$refs['modal-cancelar-nfe']) {
        this.$refs['modal-cancelar-nfe'].abrir(nfe)
      } else {
        this.$bvToast.toast('Modal não disponível', { title: 'Erro', variant: 'danger' })
      }
    },

    onNfeCancelada() {
      // Recarregar lista após cancelamento da NF-e
      this.pesquisar()
    },

    async abrirModalExportarXml(nfe) {
      if (!nfe || !nfe.ID) {
        this.$bvToast.toast('NF-e inválida', { title: 'Erro', variant: 'danger' })
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const payload = {
          nfeId: nfe.ID,
          empresaId: nfe.ID_EMPRESA || null,
          chaveAcesso: nfe.TX_CHAVE_ACESSO || null
        }

        const response = await this.$http.post('/api/protected/notaFiscal/downloadXML/', payload)
        const resultado = response.data

        if (!resultado || !resultado.sucesso || !resultado.xmlBase64) {
          const erro = resultado?.erro || 'Não foi possível exportar o XML da NF-e.'
          this.$bvToast.toast(erro, { title: 'Erro', variant: 'danger', solid: true })
          return
        }

        const byteCharacters = atob(resultado.xmlBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/xml;charset=utf-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = resultado.fileName || `${nfe.TX_CHAVE_ACESSO || `nfe-${nfe.ID}`}-nfe.xml`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } catch (err) {
        console.error('Erro ao exportar XML da NF-e:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.message || (typeof err?.response?.data === 'string' ? err.response.data : null) || err?.message || 'Erro ao exportar XML da NF-e'
        this.$bvToast.toast(mensagem, { title: 'Erro', variant: 'danger', solid: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    statusPermiteExportarXml(status) {
      return ['2', '3', '4', '7'].includes(String(status || '').trim())
    },

    labelStatusXml(status, fallback) {
      const mapa = {
        '2': 'Autorizada',
        '3': 'Cancelada',
        '4': 'Denegada',
        '7': 'Rejeitada'
      }
      const chave = String(status || '').trim()
      return mapa[chave] || fallback || chave || 'Sem situacao'
    },

    nomePessoaXmlLote(nfe) {
      return (nfe.TX_NOME_CLIENTE || nfe.TX_RAZAO_SOCIAL_DEST || nfe.TX_RAZAO_SOCIAL_EMIT || 'Nao informado').toString().trim()
    },

    documentoPessoaXmlLote(nfe) {
      return (nfe.TX_NUM_CNPJ_DEST || nfe.TX_NUM_CNPJ_EMIT || '').toString().trim()
    },

    montarResumoXmlLote(notasExportaveis, totalFiltradas) {
      const porSituacaoMap = {}
      const porPessoaMap = {}
      let totalValor = 0

      notasExportaveis.forEach(nfe => {
        const status = String(nfe.OP_STATUS || '').trim()
        const valor = Number(nfe.VL_TOTAL_NFE || 0)
        const statusKey = status || 'SEM_STATUS'
        const label = this.labelStatusXml(status, nfe.OP_STATUS_TRADUZIDO)
        const pessoaNome = this.nomePessoaXmlLote(nfe)
        const pessoaDocumento = this.documentoPessoaXmlLote(nfe)
        const pessoaKey = `${pessoaDocumento}|${pessoaNome}`

        totalValor += valor

        if (!porSituacaoMap[statusKey]) {
          porSituacaoMap[statusKey] = { status: statusKey, label, quantidade: 0, valor: 0 }
        }
        porSituacaoMap[statusKey].quantidade += 1
        porSituacaoMap[statusKey].valor += valor

        if (!porPessoaMap[pessoaKey]) {
          porPessoaMap[pessoaKey] = { nome: pessoaNome, documento: pessoaDocumento || '-', quantidade: 0, valor: 0 }
        }
        porPessoaMap[pessoaKey].quantidade += 1
        porPessoaMap[pessoaKey].valor += valor
      })

      return {
        totalNotas: notasExportaveis.length,
        totalFiltradas,
        totalIgnoradas: Math.max(totalFiltradas - notasExportaveis.length, 0),
        totalValor,
        nfeIds: notasExportaveis.map(nfe => nfe.ID).filter(Boolean),
        porSituacao: Object.values(porSituacaoMap).sort((a, b) => a.label.localeCompare(b.label)),
        porPessoa: Object.values(porPessoaMap).sort((a, b) => b.valor - a.valor)
      }
    },

    abrirConfirmacaoExportarXmlLote() {
      const filtradas = Array.isArray(this.itensFiltrados) ? this.itensFiltrados : []

      if (!filtradas.length) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhuma NF-e filtrada para exportar.')
        return
      }

      const exportaveis = filtradas.filter(nfe => this.statusPermiteExportarXml(nfe.OP_STATUS))

      if (!exportaveis.length) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nenhuma NF-e filtrada possui XML disponivel para exportacao.')
        return
      }

      this.resumoXmlLote = this.montarResumoXmlLote(exportaveis, filtradas.length)
      if (this.$refs.modalExportarXmlLote) {
        this.$refs.modalExportarXmlLote.show()
      }
    },

    nomeArquivoRespostaZip(headers) {
      const contentDisposition = headers && (headers['content-disposition'] || headers['Content-Disposition'])
      const match = contentDisposition && contentDisposition.match(/filename="?([^"]+)"?/i)
      return match && match[1] ? match[1] : `nfe-xml-lote-${moment().format('YYYYMMDD-HHmmss')}.zip`
    },

    async mensagemErroBlob(responseData) {
      if (!responseData) return null
      if (typeof responseData === 'string') return responseData
      if (responseData instanceof Blob) {
        return await new Promise(resolve => {
          const reader = new FileReader()
          reader.onload = () => resolve(reader.result)
          reader.onerror = () => resolve(null)
          reader.readAsText(responseData)
        })
      }
      return null
    },

    async confirmarExportarXmlLote() {
      if (!this.resumoXmlLote.nfeIds || !this.resumoXmlLote.nfeIds.length || this.exportandoXmlLote) return

      try {
        this.exportandoXmlLote = true
        this.$store.commit('controle/setAguardando', true)

        const payload = {
          nfeIds: this.resumoXmlLote.nfeIds,
          filtroAtual: {
            dt1: this.dt1,
            dt2: this.dt2,
            id: this.id,
            chave: this.chave,
            nota1: this.nota1,
            status: this.status,
            filtrosTabela: this.filtros,
            totalFiltrado: this.resumoXmlLote.totalFiltradas
          }
        }

        const response = await this.$http.post('/api/protected/notaFiscal/downloadXMLLote/', payload, {
          responseType: 'blob'
        })

        const blob = new Blob([response.data], { type: 'application/zip' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = this.nomeArquivoRespostaZip(response.headers)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        const exportados = response.headers && (response.headers['x-xml-exportados'] || response.headers['X-Xml-Exportados'])
        const falhas = response.headers && (response.headers['x-xml-falhas'] || response.headers['X-Xml-Falhas'])
        const mensagem = falhas && Number(falhas) > 0
          ? `ZIP gerado com ${exportados || this.resumoXmlLote.totalNotas} XML. Consulte falhas.txt para ${falhas} ocorrencia(s).`
          : `ZIP gerado com ${exportados || this.resumoXmlLote.totalNotas} XML.`

        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', mensagem)

        if (this.$refs.modalExportarXmlLote) {
          this.$refs.modalExportarXmlLote.hide()
        }
      } catch (err) {
        console.error('Erro ao exportar XML em lote:', err)
        const blobMessage = await this.mensagemErroBlob(err?.response?.data)
        const mensagem = blobMessage || err?.response?.data?.erro || err?.response?.data?.message || (typeof err?.response?.data === 'string' ? err.response.data : null) || err?.message || 'Erro ao exportar XML em lote'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', mensagem)
      } finally {
        this.exportandoXmlLote = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async abrirModalDesvincularPreFatura(nfe) {
      if (!nfe || !nfe.ID) {
        this.$bvToast.toast('NF-e inválida', { title: 'Erro', variant: 'danger' })
        return
      }

      // Solicitar confirmação
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Confirma desvincular a Pré-Fatura da NF-e ${nfe.TX_NUM_NFE || nfe.ID}?`,
        {
          title: 'Confirmar Desvinculação',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Sim, Desvincular',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (!confirmed) {
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        const payload = { nfeId: nfe.ID }
        const response = await this.$http.post('/api/protected/notaFiscal/desvincularPreFatura/', payload)
        
        const resultado = response.data

        if (resultado && resultado.sucesso) {
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Pré-Fatura desvinculada com sucesso')
          // Atualizar lista
          await this.pesquisar()
        } else {
          const erro = resultado?.erro || resultado?.mensagem || 'Erro ao desvincular Pré-Fatura'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
        }

      } catch (err) {
        console.error('Erro ao desvincular Pré-Fatura:', err)
        const mensagem = err?.response?.data?.erro || err?.response?.data?.mensagem || err?.message || 'Erro ao desvincular Pré-Fatura'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', mensagem)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    formatDate(val) { return Tools.formatarDataBR(val) },
    formatCurrency(val) { return Tools.formatCurrency(val) },

    toggleDetalhesNfe(row) {
      if (row.detailsShowing) {
        row.toggleDetails();
      } else {
        this.buscarDetalhesNfe(row.item);
        row.toggleDetails();
      }
    },

    async buscarDetalhesNfe(item) {
      if (item.detalhes && item.detalhes.length > 0) return
      
      try {
        this.$set(item, 'loading', true)
        const data = await this.$store.dispatch('nfe/GET_ITENS_BY_NFE_ID', item.ID)
        this.$set(item, 'detalhes', data || [])
      } catch (err) {
        console.error('Erro ao buscar itens da NF-e:', err)
        this.$bvToast.toast('Erro ao carregar itens da NF-e', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$set(item, 'loading', false)
      }
    },

    exportarHtml() { printHtmlReport({ rows: this.lista, columns: this.colunas, systemName: 'CECWeb', reportTitle: 'Listagem de NF-e', printedBy: window.localStorage.getItem('login') ?? '—', pageSize: 'A4', landscape: true }) },
    exportarExcel() { exportExcelXlsx({ rows: this.lista, columns: this.colunas, filename: 'nfe-lista.xls' }) },
    exportarCsv() { exportCsv({ rows: this.lista, columns: this.colunas, filename: 'nfe-lista.csv' }) }
  },

  created() { 
    //this.pesquisar() 
  },

  mounted() {
    // Set focus on dt1 input when component is mounted
    this.$nextTick(() => {
      if (this.$refs.dt1Input) {
        if (typeof this.$refs.dt1Input.focus === 'function') this.$refs.dt1Input.focus()
        else if (this.$refs.dt1Input.$el) this.$refs.dt1Input.$el.focus()
      }
    })
  },

  beforeRouteEnter(to, from, next) {
    // Quando entra na rota da listagem vindo de outra página (ex: cadastro)
    next(vm => {
      // Garantir que o aguardando está desligado ao entrar na listagem
      vm.$store.commit('controle/setAguardando', false)

      // Verifica se a flag está ativa ou se está vindo da rota de cadastro
      const deveRecarregar = vm.$store.getters['nfe/DEVE_RECARREGAR_LISTA']
      const vindoDeCadastro = from.path && from.path.includes('/faturamento/nfe/cadastro')
      
      if (deveRecarregar || vindoDeCadastro) {
        // Aguardar o próximo ciclo do Vue antes de recarregar
        vm.$nextTick(() => {
          vm.pesquisar()
          vm.$store.commit('nfe/SET_DEVE_RECARREGAR_LISTA', false)
        })
      }

      // Garantir foco no dt1 ao exibir a página
      vm.$nextTick(() => {
        if (vm.$refs.dt1Input) {
          if (typeof vm.$refs.dt1Input.focus === 'function') vm.$refs.dt1Input.focus()
          else if (vm.$refs.dt1Input.$el) vm.$refs.dt1Input.$el.focus()
        }
      })
    })
  }
}
</script>

<style lang="scss">
.list-header-premium {
  background: #fff;
  border-bottom: 1px solid #eef2f7;
  
  .header-icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    
    i {
      font-size: 1.4rem;
    }
  }
}

/* reuse CentroCusto sticky header styles */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #6c7c8d !important;
  color: #fff !important;
}

/* Modern Premium Table Styles */
.modern-premium-table thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.modern-premium-table tbody td {
  vertical-align: middle !important;
  padding: 4px 8px !important;
  color: #4a5568;
  border-bottom: 1px solid #edf2f7 !important;
}

.modern-premium-table .btn-icon-only {
  width: 28px !important;
  height: 28px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
}

.modern-premium-table .badge {
  padding: 4px 10px !important;
  font-size: 0.7rem;
}

.modern-premium-table tbody tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.modal-header-premium {
  border-bottom: none;
}

.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.bg-white-10 {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}

.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/NfeListagem.vue